import React, { Component } from "react";
import { X, MapPin, Phone, Star, Circle } from "lucide-react";

import Button from "./Button";

class FetchBusiness extends Component {
	clear = () => this.props.onClear();

	render() {
		const { business, onFetch } = this.props;
		return (
			<div className="idg-search-business idg-animate-me">
				<div className="idg-business">
					<X
						className="bl-close"
						onClick={this.clear}
						size={30}
						style={{ cursor: 'pointer' }}
					/>

					<div className="business-info">
						<h4>{business.name}</h4>
						<h6><MapPin size={14} />{business.formatted_address}</h6>
						{business.formatted_phone_number && (
							<p><Phone size={14} />{business.formatted_phone_number}</p>
						)}
						<hr/>
						<div className="business-meta">
							{business.rating ? (
								<div className="business-rating fade-in" key="rating-loaded">
									<Star size={14} />
									<span>{business.rating} / 5</span>
									{business.user_ratings_total && (
										<span className="reviews-count">({business.user_ratings_total.toLocaleString()} reviews)</span>
									)}
								</div>
							) : (
								<div className="business-rating skeleton" key="rating-loading">
									<Star size={14} />
									<span className="skeleton-text">Loading...</span>
								</div>
							)}

							{business.opening_hours && business.opening_hours.open_now !== undefined ? (
								<div className={`business-status fade-in ${business.opening_hours.open_now ? 'open' : 'closed'}`} key="status-loaded">
									<Circle size={10} />
									<span>{business.opening_hours.open_now ? 'Open Now' : 'Closed'}</span>
								</div>
							) : (
								<div className="business-status skeleton" key="status-loading">
									<Circle size={10} />
									<span className="skeleton-text">Loading...</span>
								</div>
							)}
						</div>
					</div>

					<div className="button-container">
						<Button type="green" text="Fetch links and IDs" onClick={onFetch} />
					</div>
				</div>
			</div>
		);
	}
}

export default FetchBusiness;
